import { render, staticRenderFns } from "./InfoBoard.vue?vue&type=template&id=1adb9e76&scoped=true&"
import script from "./InfoBoard.vue?vue&type=script&lang=js&"
export * from "./InfoBoard.vue?vue&type=script&lang=js&"
import style0 from "./InfoBoard.vue?vue&type=style&index=0&id=1adb9e76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb9e76",
  null
  
)

export default component.exports